import { HTMLAttributes } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { RouterPaths } from '@/constants/router';
import { CommonMenu } from '@/entities/auth/ui/common-menu';

import cls from './styles.module.pcss';
import layoutCls from '@shared/assets/styles/modules/layout.module.pcss';
import Logo from '@shared/assets/images/mk-logo.svg';
import { Typography } from '@lst/mk-fe-design-system';
import { useGetPagesQuery } from "@entities/content-page";


export function Header({ className }: HTMLAttributes<any>) {
  const { t } = useTranslation();
  const location = useLocation();
  const { data: pages = [] } = useGetPagesQuery();

  return (
    <header className={cn(cls.Header, layoutCls.Container, className)}>
      <CommonMenu />
      <div className={cls.Navigation}>
        <Link to={RouterPaths.INDEX}>
          <img className={cls.Logo} src={Logo} alt={t('common.logo_alt')} />
        </Link>

        {pages.map((page) => {
          const pagePath = `/pages/${page.id}`;
          const isActive = pagePath === location.pathname;

          return (
            <Link to={pagePath} key={page.id}>
              <Typography.Title
                uppercase
                size="l"
                variant={isActive ? 'bright' : 'midlight'}
              >
                {page.name}
              </Typography.Title>
            </Link>
          )
        })}
      </div>
    </header>
  );
}
